import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import ContentWrapper from 'components/ContentWrapper/ContentWrapper';
import useGetAssessmentSettings from 'hooks/useGetAssessmentSettings';
import { t } from 'locales/i18n';
import Deadlines from 'pages/SettingsGeneral/Deadlines';
import General from 'pages/SettingsGeneral/General';
import { AssessmentDetailsContext } from 'providers/AssessmentDetailsProvider';

const SettingsGeneral = () => {
  const { interviewUid = '' } = useParams();
  const { isPractice } = useContext(AssessmentDetailsContext);

  const { data: assessmentSettings, isLoading } =
    useGetAssessmentSettings(interviewUid);

  return (
    <ContentWrapper
      title={isPractice ? t('Practice Settings') : t('Assessment Settings')}
    >
      <General
        interviewUid={interviewUid}
        isLoading={isLoading}
        data={assessmentSettings}
      />
      {!isPractice && (
        <Deadlines
          interviewUid={interviewUid}
          isLoading={isLoading}
          data={assessmentSettings}
        />
      )}
    </ContentWrapper>
  );
};

export default SettingsGeneral;
